export function showNoti(message, type = 'success') {
  const notiHTML = `<div class="alert-box ${type}"><span>${message}</span></div>`;
  jQuery('#noti').html(notiHTML);
  jQuery('div.alert-box').fadeIn().delay(3000).fadeOut();
}

jQuery(function ($) {
  $('#shareButton').on('click', function (e) {
    e.preventDefault();

    if (navigator.share) {
      navigator
        .share({
          title: document.title,
          text: 'Xem bài viết:',
          url: window.location.href,
        })
        .then(() => console.log('Chia sẻ thành công'))
        .catch((error) => console.error('Chia sẻ thất bại:', error));
    } else {
      alert('Thiết bị hoặc trình duyệt không hỗ trợ chia sẻ.');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const swiper = new Swiper('.mySwiper', {
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction', // <- đổi từ 'bullets' sang 'fraction'
      renderFraction: function (currentClass, totalClass) {
        return '<span class="' + currentClass + '"></span>' +
          ' / ' +
          '<span class="' + totalClass + '"></span>';
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
});

jQuery('#showContentPost').on('click', function () {
  jQuery('#contentPostMenuDirections').toggleClass('origin-center rotate-90');
  jQuery('#contentPost').slideToggle();
});

jQuery('#hideContentPost').on('click', function () {
  jQuery('#contentPostMenuDirections').toggleClass('origin-center rotate-90');
  jQuery('#contentPost').slideToggle();
});



jQuery(window).on('load', function () {
  const el = document.getElementById('menuDataAction');
  if (!el) return; // Ngăn lỗi nếu phần tử không tồn tại

  const hammertime = new Hammer(el);

  // Cài đặt swipe direction
  hammertime.get('swipe').set({
    direction: Hammer.DIRECTION_ALL
  });

  hammertime.on('swipeup', function () {
    const menu = jQuery('#SideBarMenu');
    const label = jQuery('#menuDataAction p.text-label');
    const activeItem = jQuery('#SideBarMenu .active');

    if (menu.hasClass('hidden')) {
      menu.removeClass('hidden').hide().slideDown(() => {
        label.text('Ẩn danh sách bài viết')
          .removeClass('text-[#3B6CDC]')
          .addClass('text-red-500');

        if (activeItem.length) {
          menu.animate({
            scrollTop: menu.scrollTop() + activeItem.position().top - 100
          }, 400);
        }
      });
    }
  });

  hammertime.on('swipedown', function () {
    const menu = jQuery('#SideBarMenu');
    const label = jQuery('#menuDataAction p.text-label');

    if (!menu.hasClass('hidden')) {
      menu.slideUp(() => {
        menu.addClass('hidden');
        label.text('Bấm xem danh sách bài viết')
          .removeClass('text-red-500')
          .addClass('text-[#3B6CDC]');
      });
    }
  });
});


jQuery(document).on('click', '#menuDataAction', function () {
  const menu = jQuery('#SideBarMenu');
  const label = jQuery('#menuDataAction p.text-label');
  const activeItem = jQuery('#SideBarMenu .active');

  if (menu.hasClass('hidden')) {
    if (activeItem.length) {
      menu.removeClass('hidden').hide().slideDown();
      label.text('Ẩn danh sách bài viết')
        .removeClass('text-[#3B6CDC]')
        .addClass('text-red-500');
      menu.animate({
        scrollTop: menu.scrollTop() + activeItem.position().top - 100
      }, 400);
    }
    else {
      menu.removeClass('hidden').hide().slideDown();
      label.text('Ẩn danh sách bài viết')
        .removeClass('text-[#3B6CDC]')
        .addClass('text-red-500');
    }
  } else {
    menu.slideUp(() => {
      menu.addClass('hidden');
      label.text('Bấm xem danh sách bài viết')
        .removeClass('text-red-500')
        .addClass('text-[#3B6CDC]');
    });
  }
});

jQuery(document).on('click', '.category-header', function () {
  const toggleId = jQuery(this).data('toggle-id');
  const target = jQuery(`#${toggleId}`);

  target.slideToggle(300);

  jQuery(this).find('.toggleMenuIcon').toggleClass('rotate-90');
});


jQuery(function ($) {
  const key = 'favorite-post-' + window.location.pathname;

  if (localStorage.getItem(key) === 'true') {
    jQuery('#addFavorite').addClass('!bg-red-50 !text-red-500');
    jQuery('#favoriteIcon').removeClass('far fas');
    jQuery('#favoriteIcon').addClass('fas');
  }

  jQuery('#addFavorite').on('click', function () {
    console.log('click');
    const isFav = jQuery(this).hasClass('!bg-red-50 !text-red-500');
    console.log(isFav);
    if (isFav) {
      jQuery('#addFavorite').removeClass('!bg-red-50 !text-red-500');
      jQuery('#favoriteIcon').removeClass('fas far');
      jQuery('#favoriteIcon').addClass('far');
      localStorage.setItem(key, 'false');
    } else {
      jQuery('#addFavorite').addClass('!bg-red-50 !text-red-500');
      jQuery('#favoriteIcon').removeClass('fas far');
      jQuery('#favoriteIcon').addClass('fas');
      localStorage.setItem(key, 'true');
    }
  });
});